import { IValidationRule } from "@/types"

const evaluationParameterValidationRules: { [s: string]: IValidationRule } = {
    assetTypeId: {
        required: true,
    },
    financeCategoryIFRS: {
        required: true,
    },
    financeCategoryLocal: {
        required: true,
    },
    ifrsDepreciationStart: {
        required: true,
    },
    hasLocalDepreciation: {
        required: true,
    },
    extraordinaryIFRS: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
    extraordinaryLocal: {
        required: true,
        type: "decimal",
        min: 0,
        max: 100,
    },
    residualValueIFRS: {
        required: true,
        type: "decimal",
        min: 1,
        max: 100,
    },
    residualValueLocal: {
        required: true,
        type: "decimal",
        min: 1,
        max: 100,
    },
    assetCategoryId: {
        required: false,
    },
    divisionId: {
        required: false,
    }
}

export default evaluationParameterValidationRules
